import React, { Component } from "react";
import { Row, Col, Button, Modal, Container, Form } from "react-bootstrap";
import Switch from "react-switch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class EditDeliveryStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
        statusname: this.props.statuses ? this.props.statuses.name : null,
        description: this.props.statuses ? this.props.statuses.disc : null,
        sortOrder: this.props.statuses ? this.props.statuses.sortOrder:null,
        isActive:this.props.statuses ? this.props.statuses.isActive:true,
        id: this.props.statuses ? this.props.statuses.id : null,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
        statusname: nextProps.statuses && nextProps.statuses.name,
        description: nextProps.statuses && nextProps.statuses.disc,
        sortOrder: nextProps.statuses && nextProps.statuses.sortOrder,
        isActive:nextProps.statuses && nextProps.statuses.isActive,
        id: nextProps.statuses && nextProps.statuses.id,
    });
  }

  handleChange=()=>{
    this.setState({
      ...this.state,
      isActive:!this.state.isActive
    });
  }

  onChange=(ev)=>{
    let name = ev.target.name;
    let val = ev.target.value;

    if(name==="statusname"){
      this.setState({
        ...this.state,
        statusname:val,
        statusnameError:"",
      });
    }
    else if(name==="desc"){
      this.setState({
        ...this.state,
        description:val,
        descriptionError:"",
      });
    }
    else if(name==="sortorder"){
      this.setState({
        ...this.state,
        sortOrder:val,
        sortOrderError:"",
      });
    }
  }

  validate=()=>{
    let isError = false;
    const { statusname, description, sortOrder } = this.state;

    let reg = /\d/;
    const errmsg1 = "This field is mandatory";
    const errmsg = "Only numerals allowed";

    const errors = {
      statusnameError: "",
      descriptionError: "",
      sortOrderError:"",
    };

    if (statusname === "") {
      isError = true;
      errors.statusnameError = errmsg1;
    }
    if (description === "") {
      isError = true;
      errors.descriptionError = errmsg1;
    }
    if (sortOrder === "") {
      isError = true;
      errors.sortOrderError = errmsg1;
    }
    if(sortOrder != "" && !reg.test(sortOrder)) {
      isError = true;
      errors.sortOrderError = errmsg;
    }

    this.setState({
      ...this.state,
      ...errors
    });

    return isError;
  }

  submit=()=>{
    const {statusname, description, sortOrder, isActive,id } = this.state;
    let data={statusname:statusname,statusdesc:description, sortorder:sortOrder,active:isActive, id:id};

    let validate = this.validate();
    if(!validate) {
        this.props.closeEditModal();
        this.props.editDeliverystatus(data);
    }
  }

  render() {
      const { showEditModal, closeEditModal } = this.props;
      const { handleChange, onChange, submit } = this;
      const { statusname, description, sortOrder, isActive,statusnameError, descriptionError,sortOrderError } = this.state;
    return (
      <div>
        <Modal
          show={showEditModal}
          onHide={closeEditModal}
          animation={false}
          size="md"
          backdrop="static"
          centered={true}
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
            closeButton
          >
            <Modal.Title>Edit Delivery Statuses</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <Col lg={12}>
                  <Form>
                    <div style={{ maxWidth: 280, margin: "auto" }}>
                    <div>
                        <Form.Group controlId="statusName">
                          <Form.Label> Status </Form.Label>
                          <Form.Control
                            type="text"
                            autoComplete="off"
                            name="statusname"
                            onChange={onChange}
                            value={statusname}
                          />
                          <div className="errStyle">{statusnameError}</div>
                        </Form.Group>
                      </div>

                      <div>
                        <Form.Group controlId="desc">
                          <Form.Label>Description</Form.Label>
                          <Form.Control
                            as="textarea"
                            name="desc"
                            autoComplete="off"
                            onChange={onChange}
                            value={description}
                          />
                          <div className="errStyle">{descriptionError}</div>
                        </Form.Group>
                      </div>

                      <div>
                        <Form.Group controlId="sortorder">
                          <Form.Label>Sort Order</Form.Label>
                          <Form.Control
                            type="number"
                            min="0"
                            name="sortorder"
                            autoComplete="off"
                            onChange={onChange}
                            value={sortOrder}
                          />
                          <div className="errStyle">{sortOrderError}</div>
                        </Form.Group>
                      </div>

                      <div>
                        <label style={{ display: "flex", marginTop: "8px" }}>
                          <div style={{ marginRight: "30px" }}>
                            <span>Active</span>
                          </div>
                          <div style={{ marginTop: "-5px" }}>
                            <Switch
                              onChange={handleChange}
                              onColor="#20a8d8"
                              checked={isActive}
                            />
                          </div>
                        </label>
                      </div>
                    </div>
                  </Form>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
            <Button type="submit" onClick={submit}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default EditDeliveryStatus;